import type { QuoteDTO } from '@setvi/shared/services';
import type { UserData } from './steps/prepared-by';
import { TabType } from './steps/prepared-by';
import type { QuoteDisplayData } from './steps/quote-display';

export const QUOTE_DETAILS_DIALOG = 'quote-details-dialog';

export interface Step {
  id: string;
  // Stable step identity (the QuoteDetailsSteps enum). The sidebar and content
  // renderer key off this rather than the array index, so steps can be filtered
  // out (e.g. hiding "Prepared By" for non-creators) without breaking the
  // index↔content mapping.
  value: QuoteDetailsSteps;
  label: string;
  icon: string;
  completed: boolean;
  hasError?: boolean;
  iconWidth?: number | null;
  iconHeight?: number | null;
}

export enum QuoteDetailsSteps {
  PREPARED_FOR = 0,
  PREPARED_BY = 1,
  EXPIRATION_DATE = 2,
  OVERALL_NOTE = 3,
  QUOTE_DISPLAY = 4
}

export interface QuoteDetailsModalProps {
  step?: QuoteDetailsSteps;
  quote: QuoteDTO;
  onClose: () => void;
  updateQuoteInfo: (quote: Partial<QuoteDTO>) => void;
}

export interface PreparedForFormData {
  companyName: string;
  address: string;
  phoneNumber: string;
}

export interface PreparedByFormData {
  file: File | null;
  type: TabType;
  companyName: string;
  companyAddress: string;
  companyRole: string;
  usedForOtherSalesRep: boolean;
  profileTabCache: UserData;
  otherTabCache: UserData;
}

export interface QuoteDetailsFormData {
  preparedFor: PreparedForFormData;
  preparedBy: PreparedByFormData;
  expirationDate: Date;
  overallNote: string;
  quoteDisplay: QuoteDisplayData;
}
